export const deletable = {
    methods: {
        destroy(url) {
            return new Promise((resolve) => {
                this.$alert('¿Desea eliminar el registro?', 'Eliminar', {
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete(url)
                        .then(res => {
                            if(res.data.success) {
                                this.$message.success('Se eliminó correctamente el registro')
                                resolve()
                            }
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error('Error al intentar eliminar');
                            } else {
                                console.log(error.response.data.message)
                            }
                        })
                }).catch(error => {
                    console.log(error)
                });
            })
        },
        voided(url) {
            return new Promise((resolve) => {
                this.$alert('¿Desea anular el registro?', 'Anular', {
                    confirmButtonText: 'Anular',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(url)
                        .then(res => {
                            if (res.data.success) {
                                this.$message.success('Se anuló correctamente el registro')
                                resolve()
                            }
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error('Error al intentar anular');
                            } else {
                                console.log(error.response.data.message)
                            }
                        })
                }).catch(error => {
                    console.log(error)
                });
            })
        },
        close(url) {
            return new Promise((resolve) => {
                this.$alert('¿Desea cancelar el pedido?', 'Cancelar', {
                    confirmButtonText: 'Cancelar pedido',
                    cancelButtonText: 'Cerrar',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete(url)
                        .then(res => {
                            if(res.data.success) {
                                this.$message.success('El pedido fue cancelado satisfactoriamente.')
                                resolve()
                            }
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error('Error al intentar cancelar el pedido.');
                            } else if(error.response.status === 403) {
                                this.$message.error('No posee permisos para realizar esta acción.');
                            } else {
                                console.log(error.response.data.message)
                            }
                        })
                }).catch(error => {
                    console.log(error)
                });
            })
        },
        remove(url) {
            return new Promise((resolve) => {
                this.$prompt('Ingresa el motivo de la anulación', 'Eliminar', {
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar',
                    inputPattern: /\S+/,
                    inputErrorMessage: 'El motivo es obligatorio'
                }).then(({ value }) => {
                    this.$http.post(url, {
                        reason: value
                    })
                        .then(res => {
                            if(res.data.success) {
                                this.$message.success('Se eliminó correctamente el registro')
                                resolve()
                            }
                        })
                        .catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error('Error al intentar eliminar');
                            } else {
                                console.log(error.response.data.message)
                            }
                        })
                }).catch(() => {
                    this.$message.error('Error al intentar eliminar');
                });
            })
        },
    }
}